export default "__VITE_ASSET__D41JHd75__"